import { Component } from '@angular/core';
import { Alert, AlertModule, AlertService, AlertType, MainContentModule, SidebarModule, StatusModule } from '@michelin/theme';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatDialogActions, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ChangePasswordService } from '../../shared/services/change-password/change-password.service';
import { ChangePasswordDto } from '../../shared/models/change-password/change-password-dto';
import { AuthService } from '../../shared/services/auth/auth.service';

@Component({
  selector: 'mic-change-password',
  imports: [
    AlertModule,
    MainContentModule,
    MatButton,
    MatCard,
    MatCardContent,
    MatDialogActions,
    MatFormField,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    SidebarModule,
    StatusModule,
    TranslateModule
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.scss'
})
export class ChangePasswordComponent {
  form: FormGroup;
  hide: boolean = true;
  hideNewPassword: boolean = true;
  hideNewPassword2: boolean = true;

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    private translate: TranslateService,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private changePasswordService: ChangePasswordService,
    private authService: AuthService
  ) {
    this.form = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      newPassword2: ['', Validators.required]
    });
  }

  showAlert(type: AlertType, content: string) {
    this.alertService.showAlert({
      type: type,
      content: content
    } as Alert);
  }

  onClose(result: boolean): void {
    this.dialogRef.close(result);
  }

  onSave() {
    if (!this.form.valid) {
      this.showAlert(AlertType.strong, this.translate.instant('app.feedback.formInvalid'));
      return;
    }

    let currentPassword = this.form.get('currentPassword').value;
    let newPassword = this.form.get('newPassword').value;
    let newPassword2 = this.form.get('newPassword2').value;

    if (newPassword !== newPassword2) {
      this.showAlert(AlertType.strong, this.translate.instant('app.changePassword.notification.passwordDoesNotMatch'));
      return;
    }

    if (!this.changePasswordService.checkPattern(newPassword)) {
      this.showAlert(AlertType.strong, this.translate.instant('app.changePassword.notification.invalidPattern'));
      return;
    }

    if (newPassword === currentPassword) {
      this.showAlert(AlertType.strong, this.translate.instant('app.changePassword.notification.passwordPreviouslyUsed'));
      return;
    }

    let changePasswordDto: ChangePasswordDto = new ChangePasswordDto();
    changePasswordDto.login = this.authService.getUsername();
    changePasswordDto.newPassword = newPassword;
    changePasswordDto.currentPassword = currentPassword;

    this.changePasswordService.updatePassword(changePasswordDto).subscribe({
      next: (response) => {
        this.showAlert(AlertType.success, this.translate.instant('app.changePassword.successMessage'));
        this.dialogRef.close();
      },
      error: (error) => {
        console.log(error);
        if (error.status === 422) {
          this.showAlert(AlertType.strong, this.translate.instant('app.changePassword.notification.invalidCurrentPassword'));
        }
      }
    });
  }
}
